// extracted by mini-css-extract-plugin
module.exports = {"container":"_2U4wA___Input-module__container","label":"AkCsI___Input-module__label","input":"_2Bs-J___Input-module__input"};